export default __webpack_public_path__ + "static/media/Mark-3-HUD-03.27b11717.jpg";